import { createGlobalStyle } from 'styled-components'
import { getPaletteColor } from 'pcln-design-system'

const GlobalStyle = createGlobalStyle`
  body {
  background-color: ${getPaletteColor('background.lightest')};
  margin: 0;
  padding: 0;

  &.mobile-menu-activated {
    .app-banner {
      position: relative;
      left: -100vw;
      width: 100vw;
    }
  }
}

// TODO: Cleanup once Okta is enabled in Production
.googot-iframe {
  top: 88px !important;
  right: 14px !important;
}
`
export default GlobalStyle
